import {appStore} from "@store/appStore";
import {LoginService} from "../login/loginService.ts";


class Auth {

    async login(username: string, password: string) {
        try {
            const service = new LoginService();
            const loginInfo = await service.login(username, password);
            if (loginInfo.token) {
                this.applyLoginInfo(loginInfo);
            }
            return loginInfo;
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    }

    async mfaLoginGoogle(loginChallenge: string, idToken: string) {
        const service = new LoginService();
        const loginInfo = await service.mfaLoginGoogle(loginChallenge, idToken);
        this.applyLoginInfo(loginInfo);
        return loginInfo;
    }

    private applyLoginInfo(loginInfo: { token: string; user: any }) {
        appStore.authToken = loginInfo.token;
        appStore.loggedInUser = loginInfo.user;
    }

    async tokenLogin() {
        try {
            const service = new LoginService();
            const loginInfo = await service.tokenLogin(appStore.authToken);

            appStore.loggedInUser = loginInfo.user;
            appStore.authToken = loginInfo.token;

            return loginInfo;
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    }

    isAuthenticated_old() : boolean {

        if (appStore.authToken.length > 0)
            return true;

        /*
            const currentDate = new Date().toISOString();
            const expDate = (sessionStorage.getItem('tokenExpiration') && JSON.parse(sessionStorage.getItem('tokenExpiration')!).expirationDate);
            if (!sessionStorage.getItem('tokenExpiration') ||
                (expDate <= currentDate)) {
                return false;
            }
         */
        return false;
    }

    logOut() : void{
        this.clearStorages();
        this.removeToken();
        window.location.href = '/';
    }

    saveUserSession(value: string, limitDate: Date) : void {
        const newValue = {
            value: value,
            expirationDate: new Date(limitDate.setDate(new Date().getDate() + 1)).toISOString() //tomorrow date
        };
        window.sessionStorage.setItem("tokenExpiration", JSON.stringify(newValue));
    }


    clearStorages() : void  {
        sessionStorage.clear();
        localStorage.clear();
    }

    removeToken() : void  {
        sessionStorage.removeItem('tokenExpiration');
    }

    getToken() : string {

        return appStore.authToken;
    }
}

export default new Auth();
